export default {
  professionals: {
    loading: false,
    lastUpdate: null,
    data: [],
    isActive: true,
  },

  allProfessionals: {
    loading: false,
    lastUpdate: null,
    data: [],
    isActive: true,
  },

  churn: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  goals: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
  goalsManager: {
    loading: false,
    lastUpdate: null,
    data: [],
  },

  statistics: {
    loading: false,
    lastUpdate: null,
    data: [],
  },

  corporatePoll: {
    loading: false,
    lastUpdate: null,
    data: [],
  },

  userReturnDestination: {
    url: '',
  },
  bankDetails: {
      loading: false,
      lastUpdate: null,
      data: [],
  },
  // {{NEXT}}
}
